import { z } from 'zod';
import { DeviceAuthorizationStatus } from '../enums.js';

export const getDeviceAuthorizationsSchema = z.object({
  status: z.enum([DeviceAuthorizationStatus.APPROVED, DeviceAuthorizationStatus.REVOKED]).optional(),
});

export type GetDeviceAuthorizationsPayload = z.infer<typeof getDeviceAuthorizationsSchema>;
